import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from "redux";

import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Configuration from '../../config/Config';

import { TextField, Dropdown, Panel } from '@ktr/ktr-materialui-react';

import { LayoutInputState, updateLayoutInputAction } from '../../store/reducers/LayoutInputReducer'
import { LayoutOutputState, updateLayoutOutputAction, updateInvalidateAction } from '../../store/reducers/LayoutOutputReducer'
import { LayoutResult, LayoutInput, performFetch, createUrlLayout } from '../../service/ServiceAPI';

import { RootState } from '../../store/Store';

import { useTranslation } from 'react-i18next';
//import { setConstantValue } from 'typescript';


// ---------------------------------------------------
// ---------------------------------------------------
// CSS
// ---------------------------------------------------
const useStyles = makeStyles(theme => ({
  inputstyle: {
    //backgroundColor: theme.palette.background.default,
    //color: theme.palette.primary.main, 
    //border: '1px solid black',
    //padding: '10px',
    //marginLeft: '5px',
    //marginRight: '5px',
  },
  subinputstyle: {
    //backgroundColor: 'white',
    //color: 'darkgray',
    border: '1px solid orange',
    padding: '10px',
    margin: '5px',
  },
  subsideinputstyle: {
    //backgroundColor: 'white',
    //color: 'darkgray',
    border: '1px solid brown',
    padding: '10px',
    margin: '5px',
  },

}));



// ---------------------------------------------------
// ---------------------------------------------------
// Properties
// ---------------------------------------------------

type Props = {
  //title?: string
}

// we need two portions of properties to have interfaces/types for each redux-mapping-method (mapStateToProps/mapDispatchToProps)
type PropsStatic = {
    layoutInput: LayoutInput
}

type PropsHandler = {
    updateLayoutInput(state: LayoutInputState): any,
    updateInvalidate(state: LayoutOutputState): any,
    updateLayoutOutput(state: LayoutOutputState): any
}


// ---------------------------------------------------
// ---------------------------------------------------
// REDUX store
// ---------------------------------------------------

// Map component-properties to redux-store parts (input is the state, we return the according properties)
// this is the way from redux-store to component-properties
function mapStateToProps(state: RootState): PropsStatic {
  return {
    layoutInput: state.input.layoutInput,                   // combined state  
  };
}

// Map handler to redux-store actions and place these handler methods into the component-props
// this is the way from component-properties to redux-store (by initiating actions in the redux-store to update it's state)
const mapDispatchToProps = (dispatch: Dispatch): PropsHandler => ({
  updateLayoutInput: (state: LayoutInputState) => dispatch(updateLayoutInputAction(state)),
  updateInvalidate: (state: LayoutOutputState) => dispatch(updateInvalidateAction(state)),
  updateLayoutOutput: (state: LayoutOutputState) => dispatch(updateLayoutOutputAction(state))
});

// Concatenate the two property-type-portions to a single property-type to be used in the component-creation
type InputComponentProps = Props & PropsStatic & PropsHandler;


//
var testCase = 0;

// ---------------------------------------------------
// ---------------------------------------------------
// Component
// ---------------------------------------------------
const InputComponent = (props: InputComponentProps) => {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [calculating, setCalculating] = useState<Boolean>(false);

  const { t, i18n } = useTranslation();
  //const { t } = useTranslation();

  // ---------------------------------------------------
  // handle key to add debug input data.
  const upHandler = (event: KeyboardEvent) => {
    let keyName: string = event.key;

    if (keyName === 'Control') {
      return;
    }

    if (keyName === 'Alt') {
      return;
    }

    if (keyName === 'Shift') {
      return;
    } 

    if (keyName === 'Enter') {
      //performLayoutRequest();
    } 

    if(event.ctrlKey && event.altKey) {  // ctrl-alt pressed
      if (keyName === 'd') {
        toggleDebugData();
      }
      else if (keyName === 'c') {
        clearInputData();
      }

    }
  };

  // useEffect replaces onDidMount etc. for functional components:
  useEffect(() => {
    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keyup', upHandler);
    };
  }, [ upHandler ]);

  function clearInputData() {
    setInputData('Oil ISO VG 46', 'Water', '', '', '', '', '');
  }

  function clickInputDebugData(event: React.MouseEvent<HTMLElement>) {
    toggleDebugData()
  }

  function toggleDebugData() {
    switch(testCase) {
      case 0: {
        setInputData('Oil ISO VG 46', 'Water', '50.0', '15.0', '100.0', '70.0', '60.0');
        testCase++;
        break;
      }
      case 1: {
        setInputData('Oil ISO VG 46', 'Water', '50.0', '15.0', '100.0', '100.0', '60.0');
        testCase++;
        break;
      }
      case 2: {
        setInputData('Oil ISO VG 46', 'Water', '50.0', '15.0', '50.0', '50.0', '50.0');
        testCase++;
        break;
      }
      case 3: {
        setInputData('Water', 'Water', '50.0', '15.0', '50.0', '50.0', '50.0');
        testCase++;
        break;
      }
      case 4: {
        setInputData('Water', 'Water', '50.0', '21.0', '20.0', '20.0', '10.0');
        testCase++;
        break;
      }
      case 5: {
        setInputData('Water', 'Water', '80.0', '20.0', '20.0', '10.0', '5.0');
        testCase = 0;
        break;
      }
      //default: {
      //  setInputData('Oil ISO VG 46', 'Water', '50.0', '15.0', '100.0', '100.0', '60.0');
      //  testCase = 0;
      //  break;
      //}
    }
  }


  function setInputData(fluidSide1:string, fluidSide2:string, inTempSide1:string, inTempSide2:string, volumeFlowSide1:string, volumeFlowSide2:string, heatDissipation:string) {
    const state: LayoutInputState = {
      layoutInput: { ...props.layoutInput, fluidSide1: fluidSide1, fluidSide2: fluidSide2, inTempSide1: inTempSide1, inTempSide2: inTempSide2, volumeFlowSide1: volumeFlowSide1, volumeFlowSide2: volumeFlowSide2, heatDissipation: heatDissipation }
    }
    props.updateLayoutInput(state);

    // dispatch action to update isInvalid-entry in redux-state:
    var stateInvalidate: LayoutOutputState = {
      isInvalid: true,
    }
    props.updateInvalidate(stateInvalidate);
  }


  // ---------------------------------------------------
  function inputChanged(event: React.ChangeEvent<HTMLInputElement>) {
      var eventName: string = event.target.name;
      var eventValue: any = event.target.value;

      // dispatch action to update redux-state:
      //if((eventValue === "false") || (eventValue === "true")) {
      if(event.target.type === "checkbox") {
        eventValue = event.target.checked;
      }
      else 
      {
        eventValue = event.target.value;
      }
      
      //if(event.target.name === 'operation-dropdown') {
      //  if(props.layoutInput.operation === 'rate') {
      //    setVisible(false);
      //  }
      //  else {
      //    setVisible(true);
      //  }
      //}

      const state: LayoutInputState = {
        layoutInput: { ...props.layoutInput, [eventName]: eventValue }
      }
      props.updateLayoutInput(state);

      // dispatch action to update isInvalid-entry in redux-state:
      var stateInvalidate: LayoutOutputState = {
        isInvalid: true,
        //layoutOutput: { ...layoutOutput }
      }
      props.updateInvalidate(stateInvalidate);
  }

  // ---------------------------------------------------
  function handleSubmit (event: React.MouseEvent<HTMLElement>) {
    performLayoutRequest();
  }

  async function performLayoutRequest() {
    // throw new Error('I crashed!');    / not properly working with ErrorBoundary, most likely because this is a functional component (?)

    // ---
    // Test for missing mandatory input fields:
    if(props.layoutInput.fluidSide1 === '') {
      setErrorMessage(t("missinginput") + t("inputdata.fluid1"));
      return;
    }
    else if(props.layoutInput.fluidSide2 === '') {
      setErrorMessage(t("missinginput") + t("inputdata.fluid2"));
      return;
    }
    else if(props.layoutInput.inTempSide1 === '') {
      setErrorMessage(t("missinginput") + t("inputdata.tempin1"));
      return;
    }
    else if(props.layoutInput.inTempSide2 === '') {
      setErrorMessage(t("missinginput") + t("inputdata.tempin2"));
      return;
    }
    else if(props.layoutInput.volumeFlowSide1 === '') {
      setErrorMessage(t("missinginput") + t("inputdata.volumeflow1"));
      return;
    }
    else if(props.layoutInput.volumeFlowSide2 === '') {
      setErrorMessage(t("missinginput") + t("inputdata.volumeflow2"));
      return;
    }
    else if((props.layoutInput.heatDissipation === '') && (props.layoutInput.operation === "rate")) {
      setErrorMessage(t("missinginput") + t("inputdata.heatdissipation"));
      return;
    }

    // ---
    setErrorMessage("");
    setCalculating(true);

    //
    let lang: string = i18n.language;
    var url: string = createUrlLayout(props.layoutInput, lang);

    // asynchronous: we wait for the fetch to be finished (performFetch delivers a Promise):
    // await-syntax:
    var resultList: LayoutResult[];
    try {
      resultList = await performFetch(url);         // perform fetch is from ServiceAPI.ts
    }
    catch (e) {
      resultList = [];
      console.error(e);   // handle errors
      setErrorMessage(e.message);
    }
  
    // write result into redux store:
    // fire action:
    var state: LayoutOutputState = {
      isInvalid: false,
      layoutOutput: resultList
    }
    props.updateLayoutOutput(state);

    setCalculating(false);
  }
      

    //
    //const [visible, setVisible] = React.useState(false);
    //const handleVisibleClick = () => {
    //  setVisible(!visible);
    //};



  // --------------------------------------------------------------------
  

  // --------------------
  const classes = useStyles(); 
  
  return (
    <Grid container className={classes.inputstyle} >
      <Grid item xs={12}>
        <h1>{t('titleapplication')}</h1>
      </Grid>
      <Grid item xs={12}>
        <h2 onDoubleClick={clickInputDebugData}>{t('titleinput')}</h2>
      </Grid>

      <Grid item xs={12} md={4}>
        <Panel title = {t('inputdata.titlebasedata')}>
          <Dropdown
              id="operation-dropdown"
              select
              label= {t('inputdata.operation')}
              value={props.layoutInput.operation}
              onChange={inputChanged}
              helperText=""
              //margin="dense"
              //variant="outlined"
              getOptionLabel= {(l:any) => l.text }
              getOptionValue= {(l:any) => l.value }
              name="operation"
              items= { [ 
                { value: "rate", text: t('operation_rating') }, 
                { value: "performance", text: t('operation_performance') }
              ] }
            >
          </Dropdown>

          { 
          props.layoutInput.operation !== "rate" ? 
            <Dropdown
                id="phename-dropdown"
                select
                label= {t('inputdata.cooler')}
                value={props.layoutInput.phename}
                onChange={inputChanged}
                helperText=""
                //margin="dense"
                //variant="outlined"
                getOptionLabel= {(l:any) => l.text }
                getOptionValue= {(l:any) => l.value }
                name="phename"
                items= { [ 
                  { value: "", text: "..." }, 
                  { value: "PHE100x20", text: "PHE100x20" }, 
                  { value: "PHE100x40", text: "PHE100x40" }, 
                  { value: "PHE200x20", text: "PHE200x20" }, 
                  { value: "PHE200x40", text: "PHE200x40" }, 
                  { value: "PHE200x60", text: "PHE200x60" }, 
                  { value: "PHE300x40", text: "PHE300x40" },
                  { value: "PHE300x50", text: "PHE300x50" },
                  { value: "PHE300x60", text: "PHE300x60" },
                  { value: "PHE300x80", text: "PHE300x80" },
                  { value: "PHE500x40", text: "PHE500x40" },
                  { value: "PHE500x60", text: "PHE500x60" }
                ] }
              >
            </Dropdown>
            : null
          }
          { 
          props.layoutInput.operation === "rate" ? 
            <TextField
                name="heatDissipation"
                type="number"
                error={false}
                errorText="Wrong Text"
                value={props.layoutInput.heatDissipation}
                onChange={(e) => inputChanged(e)}
                labelBefore= {t('inputdata.heatdissipation')}
                labelAfter={'kW'}
              />
             : null
           }

        </Panel>
      </Grid>

      <Grid item xs={12} md={4}>
          <Panel title= {t('inputdata.titleside1')}>
            <TextField
              name="inTempSide1"          
              type="number"
              error={false}
              errorText="Wrong Text"
              value={props.layoutInput.inTempSide1}
              onChange={(e) => inputChanged(e)}
              labelBefore= {t('inputdata.tempin1')}
              labelAfter={'°C'}
            />
            <TextField
              name="volumeFlowSide1"          
              type="number"
              error={false}
              errorText="Wrong Text"
              value={props.layoutInput.volumeFlowSide1}
              onChange={(e) => inputChanged(e)}
              labelBefore= {t('inputdata.volumeflow1')}
              labelAfter={'l/min'}
            />
            <Dropdown
              id="fluidSide1-dropdown"
              select
              label= {t('inputdata.fluid1')}
              value={props.layoutInput.fluidSide1}
              onChange={inputChanged}
              helperText=""
              //margin="dense"
              //variant="outlined"
              name="fluidSide1"
              getOptionLabel= {(l:any) => l.text }
              getOptionValue= {(l:any) => l.value }
              items= { [ 
                { value: "Oil ISO VG 32", text: "Oil ISO VG 32" }, 
                { value: "Oil ISO VG 46", text: "Oil ISO VG 46" }, 
                { value: "Oil ISO VG 68", text: "Oil ISO VG 68" }, 
                { value: "Oil ISO VG 100", text: "Oil ISO VG 100" }, 
                { value: "Oil ISO VG 150", text: "Oil ISO VG 150" }, 
                { value: "Oil ISO VG 220", text: "Oil ISO VG 220" }, 
                { value: "Oil ISO VG 320", text: "Oil ISO VG 320" }, 
                { value: "Oil ISO VG 460", text: "Oil ISO VG 460" }, 
                { value: "Water", text: t('fluidwater') }, 
              ] }
            >
            </Dropdown>
          </Panel>
        </Grid>

        <Grid item xs={12} md={4}>
          <Panel title= {t('inputdata.titleside2')}>
            <TextField
              name="inTempSide2"
              type="number"
              error={false}
              errorText="Wrong Text"
              value={props.layoutInput.inTempSide2}
              onChange={(e) => inputChanged(e)}
              labelBefore= {t('inputdata.tempin2')}
              labelAfter={'°C'}
            />
            <TextField
              name="volumeFlowSide2" 
              type="number"
              error={false}
              errorText="Wrong Text"
              value={props.layoutInput.volumeFlowSide2}
              onChange={(e) => inputChanged(e)}
              labelBefore= {t('inputdata.volumeflow2')}
              labelAfter={'l/min'}
            />
            <Dropdown
              id="fluidSide2-dropdown"
              select
              label= {t('inputdata.fluid2')}
              value={props.layoutInput.fluidSide2}
              onChange={inputChanged}
              helperText=""
              //margin="dense"
              //variant="outlined"
              getOptionLabel= {(l:any) => l.text }
              getOptionValue= {(l:any) => l.value }
              name="fluidSide2"
              items= { [ 
                { value: "Water", text: t('fluidwater') }, 
                { value: "Water-Eth.glycol (50-50)", text: "Water-Eth.glycol (50-50)" }, 
              ] }
            >
            </Dropdown>
          </Panel>
        </Grid>

        <Grid item xs={12}>
          <Panel title="">
            <Button variant="outlined" color="primary" style={{"minWidth":"200px", "width": "100%", color: "white"}} onClick={handleSubmit}>{props.layoutInput.operation === "rate" ? t('operation_rating') : t('operation_performance') } </Button>
            <span style={{float: 'right'}}>{calculating === true ? <b>{t('calculating')}</b> : ""}</span>
          </Panel>
        </Grid>

        { 
          errorMessage !== "" ? 
            <Grid item xs={12}>
              <Panel title="">
                <span style={{color: '#F29400', fontWeight: 'bold', fontSize: '150%' }}>{errorMessage}</span>
              </Panel>
            </Grid>
          : null
        }

        <span style={{float: 'right'}}>Version {Configuration.version}</span>
    </Grid>

  );

};

export default connect(mapStateToProps, mapDispatchToProps)(InputComponent);
